export default "__VITE_PUBLIC_ASSET__dc437ec0__"